import React from "react";
import STCLogoLong from "./STCLogo.Long/STCLogo.Long";
import STCLogoSquare from "./STCLogo.Square/STCLogo.Square";
import STCLogoBordered from "./STCLogo.Bordered/STCLogo.Bordered";

function STCLogo(props){
    return(
        <>{props.children}</>
    )
}

STCLogo.Long = STCLogoLong;
STCLogo.Square = STCLogoSquare;
STCLogo.Bordered = STCLogoBordered;

export default STCLogo;